import { Api } from '@monorepo/shared/apiClient';
import {
  invalidateResourceCache,
  ResourceCacheEvents,
} from '@monorepo/shared/cacheRegisters/data2/resourceCacheRegister';
import { setCache as setResourceCache } from '@monorepo/shared/hooks/resources/useResource';
import { ResourceResponse } from 'mapistry-shared';
import { MutationConfig, useMutation } from 'react-query';

type useResourceCreateParams = {
  config?: MutationConfig<ResourceResponse, Api.ErrorResponse>;
};

export const useResourceCreate = (params?: useResourceCreateParams) =>
  useMutation(Api.createResource, {
    ...params?.config,
    onSuccess: async (createdResource, mutationFuncParams) => {
      const { organizationId, resourceTypeId } = mutationFuncParams;

      // Set cache for that single resource
      const keyParams = {
        organizationId,
        resourceTypeId,
        resourceId: createdResource.id,
      };
      setResourceCache(keyParams, createdResource);

      invalidateResourceCache(ResourceCacheEvents.CREATE, keyParams);

      return params?.config?.onSuccess?.(createdResource, mutationFuncParams);
    },
  });
